import { Link, useLocation } from 'react-router-dom';
import logo from 'assets/img/logo.svg';
import PageHeaderUser from './PageHeaderUser';
import PageHeaderAuth from './PageHeaderAuth';
import PageHeaderNav from './PageHeaderNav';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import useProfile from 'hooks/useProfile';

const PageHeader = () => {
  const {pathname} = useLocation();
  const {isLogged} = useProfile();
  const [isNavOpened, setIsNavOpened] = useState(false);

  useEffect(() => {
    setIsNavOpened(false);
  }, [pathname])

  return (
    <header className={`page-header ${isNavOpened ? 'opened' : ''}`}>
      <Link to="/" className="page-header__home">
        <img src={logo} alt="220k logo" />
      </Link>
      <PageHeaderNav setIsNavOpened={setIsNavOpened} isLogged={isLogged} />
      {
        isLogged ?
          <PageHeaderUser />
          :
          <PageHeaderAuth />
      }
      <button className='page-header__user-menu-button' onClick={() => setIsNavOpened(!isNavOpened)}></button>
    </header>
  )
}

export default PageHeader;
